module.exports = __webpack_public_path__ + "img/csr_swiper_05.55366629.jpg";